// extracted by mini-css-extract-plugin
export default {"root":"ExploratoryPageExtraContentContainer-module__root___5FxFz","dsrpFAQSection":"ExploratoryPageExtraContentContainer-module__dsrpFAQSection___X_6GB"};